import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class QuotaArticleApi extends CrudBase {

  search = (text) => axios.get(`${this.endpoint}/get-by?text=${text}`);
  getAll = () => axios.get(`${this.endpoint}/get-all`);

  defaultMethods = {
    search: this.search,
    getAll: this.getAll
  }
};

const quotaArticle = new QuotaArticleApi('api/v1/quota-article');

export default quotaArticle.defaultMethods;
